import * as yup from 'yup';

import { EMAIL_REGEX, isValidPhoneNumber, validateName } from '@aqx-core/common/validators';

import { i18n } from '../i18n';

export const createSignUpDemoSchema = () =>
  yup.object().shape({
    firstName: yup
      .string()
      .required(() => i18n.t('First name is required.'))
      .test(
        'is-valid-name',
        () => i18n.t('Please enter a valid name.'),
        (value) => !!value && validateName(value)
      ),
    lastName: yup
      .string()
      .required(() => i18n.t('Last name is required.'))
      .test(
        'is-valid-name',
        () => i18n.t('Please enter a valid name.'),
        (value) => !!value && validateName(value)
      ),
    email: yup
      .string()
      .required(() => i18n.t('Email is required.'))
      .matches(EMAIL_REGEX, () => i18n.t('Please enter a valid email.')),
    dialCode: yup.string().required(() => i18n.t('Dial code is required.')),
    localPhoneNumber: yup
      .string()
      .required(() => i18n.t('Phone number is required.'))
      .test(
        'is-valid-phone',
        () => i18n.t('Please enter a valid phone number.'),
        function (value) {
          const { dialCode } = this.parent;
          if (!dialCode || !value) {
            return false;
          }
          return isValidPhoneNumber(dialCode, value);
        }
      ),
    depositAmount: yup.number().required(() => i18n.t('Deposit is required.')),
    agree: yup
      .boolean()
      .required(() => i18n.t('Please review and accept the Terms and Conditions.'))
      .oneOf([true], () => i18n.t('Please review and accept the Terms and Conditions.')),
    country: yup.string().required(() => i18n.t('Country is required.'))
  });
